import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  TEXT_VARIANT_STANDARD,
  Text,
} from 'mailup-web-components'

import {
  modalEngagementUpsellingCancelCallback,
  modalEngagementUpsellingChangeCallback,
  modalEngagementUpsellingConfirmCallback,
} from 'Pages/RecipientsOverview/recoil/callbacks/modalEngagementUpselling'
import {
  modalEngagementUpsellingCanConfirmState,
  modalEngagementUpsellingState,
} from 'Pages/RecipientsOverview/recoil/state/modalEngagementUpselling'

const ModalEngagementUpselling: FC = () => {
  const intl = useIntl()
  const { show, email, isDirty } = useRecoilValue(modalEngagementUpsellingState)

  const canConfirm = useRecoilValue(modalEngagementUpsellingCanConfirmState)

  const change = useRecoilCallback(modalEngagementUpsellingChangeCallback, [])
  const handleCancel = useRecoilCallback(
    modalEngagementUpsellingCancelCallback,
    [],
  )

  const handleConfirm = useRecoilCallback(
    modalEngagementUpsellingConfirmCallback,
    [],
  )

  const handleEmailInputChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    void change(value)
  }

  const showFeedback = !canConfirm && isDirty

  return (
    <Modal
      show={show}
      data-mu-test="modal-engagement-upselling-contact"
      onClose={handleCancel}
      closeOnOverlayClick
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalDelStatsContactTitle',
        })}
      />

      <ModalBody>
        <Flex flexDirection="column" gap="24px">
          <Text variant={TEXT_VARIANT_STANDARD}>
            {intl.formatMessage({
              id: 'Load.RecipientsList.ModalDelStatsContactDescription',
            })}
          </Text>
          <FormElement
            labelFor="email-contact"
            label={intl.formatMessage({
              id: 'Load.RecipientsList.ModalDelStatsContactEmailLabel',
            })}
            required
            variant={showFeedback ? 'danger' : undefined}
            feedback={
              showFeedback
                ? intl.formatMessage({ id: 'Load.MailupCommon.EmptyEmail' })
                : undefined
            }
          >
            <InputText
              id="email-contact"
              onChange={handleEmailInputChange}
              value={email}
              variant={showFeedback ? INPUT_TEXT_VARIANT_DANGER : undefined}
            />
          </FormElement>
        </Flex>
      </ModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleConfirm}
          disabled={!canConfirm}
          data-mu-test="modal-engagement-upselling-contact__confirm"
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalEngagementUpselling
